import { PricingItem } from "src/app/core/models/quote/pricing-item/pricing-item";
import { DevicePricingItem } from "src/app/core/models/quote/pricing-item/device-pricing-item";
import { BillingLine } from 'src/app/core/models/billing-line/billing-line.model';
import { DiscoPricingItemInitializer } from "../disco.pricing-item-initializer";


export class DiscoDasriRenewalPricingItemInitializer extends DiscoPricingItemInitializer {

    initUserInputs(customerContract: BillingLine, prefilledInputs: any, pricingItem: PricingItem) {
        let userInputs = super.initUserInputs(customerContract, prefilledInputs, pricingItem);
        if (pricingItem instanceof DevicePricingItem) {
            Object.assign(userInputs, {
                franchiseConso: customerContract.consumptionAllowance,
            })
        }

        return userInputs;
    }

}
